<template>
	<div>
		<div :class="whiteStyle == true ? 'int-foot bgwhite' : 'int-foot'">
			<p>
				©2020 一起飞同行站点
				<a href="http://www.beian.miit.gov.cn/" target="_blank">粤ICP备14099362号-8</a>
			</p>
			<div class="fixedbox" id="drag" v-if="mon == false">
				<a href="javascript:;" @click="bindJumpFeiFei">
					<img class="addmove" src="../assets/online_counsel.png" width="22" />
					<p class="mt5 ft12">在线客服</p>
				</a>
				<a @click="showFeedback = true">
					<img src="../assets/feedback.png" width="20" />
					<p class="mt5 ft12">意见反馈</p>
				</a>
			</div>
		</div>
		<el-dialog title="意见反馈" class="dialog-box feedModal Modal" :visible.sync="showFeedback" width="50%">
			<el-form ref="form" :model="form">
				<p class="yijian">您的意见将帮助我们更好的改进产品与服务,请选择反馈类型</p>
				<div class="choicebox">
					<span v-for="(item, index) in feedback" :class="'feeditem' + (index == form.productId ? ' active' : '')" :key="index" @click="ClickActive(index)">
						{{ item }}
					</span>
				</div>
				<div class="mt10 mb10"><el-input type="textarea" :rows="12" placeholder="请输入内容" v-model="form.feedbackContent"></el-input></div>
				<div class="uploadbox">
					<p class="mb10">上传相关截图</p>
					<div class="mode" v-if="form.imageUrl != ''"><el-image :src="form.imageUrl" style="width: 300px;height: 200px;" :fit="fit"></el-image></div>

					<el-upload
						action="https://3gapitest.yiqifei.com/Upload/ProessUploadImages"
						list-type="picture-card"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload"
					>
						<i class="el-icon-plus"></i>
					</el-upload>
					<!-- <el-dialog :visible.sync="dialogVisible">
	         <img width="100%" :src="dialogImageUrl" alt="">
	       </el-dialog>    -->
				</div>
				<div class="mt15 mb15">
					<span class="contack-way">您的联系方式</span>
					<el-radio v-model="form.sex" label="1">先生</el-radio>
					<el-radio v-model="form.sex" label="2">女士</el-radio>
				</div>
				<span slot="footer" class="dialog-footer"><el-button type="danger">提交</el-button></span>
				<div>
					<div class="demo-input-size mt15">
						称呼
						<el-input placeholder="请选择称呼" v-model="form.name"></el-input>
						手机
						<el-input placeholder="请输入手机" v-model="form.phone"></el-input>
					</div>
					<div class="demo-input-size mt15">
						邮箱
						<el-input placeholder="请输入邮箱" v-model="form.email"></el-input>
					</div>
				</div>
				<div class="text-c" style="padding-top: 40px;">
					<span slot="footer" class="dialog-footer">
						<el-button @click="showFeedback = false">取 消</el-button>
						<el-button type="danger" class="button mt25"  @click="bindSubmitFeedback">确 定</el-button>
					</span>
				</div>
			</el-form>
		</el-dialog>

		<div class="gotop" v-show="gotop" @click="toTop"><span class="iconfont icon-xiangshang1"></span></div>
	</div>
</template>

<script>
import { getAccountInfo } from '@/utils/localdatas';
import { SubmitFeedBack } from '@/api/memberApi';

var that;
var util = require('@/utils/util.js');

export default {
	name: 'Footer',
	props: ['whiteStyle','mon'],
	data() {
		return {
			gotop: false,
			showFeedback: false,
			ActiveIndex: 1,
			fit: 'fill',
			feedback: ['产品预订类', '客户服务类', '平台体验类', '其他'],
			form: {
				feedbackContent: '',
				name: '',
				phone: '',
				sex: '1',
				email: '',
				imageUrl: '',
				productId: 0
			},
			accountinfo: getAccountInfo()
		};
	},
	created() {
		//生命周期里接收参数
		that = this;
		if (!util.isNullOrEmpty(that.accountinfo)) {
			that.form.name = that.accountinfo.Name;
			that.form.phone = that.accountinfo.Mobile;
			that.form.email = that.accountinfo.Email;
		}
	},
	mounted() {
		// 此处true需要加上，不加滚动事件可能绑定不成功
		window.addEventListener('scroll', this.handleScroll, true);
	},
	methods: {
		ClickActive(e) {
			console.log(e);
			that.form.productId = e;
		},
		// handleRemove(file, fileList) {
		// 	console.log(file, fileList);
		// },
		// handlePictureCardPreview(file) {
		// 	this.dialogImageUrl = file.url;
		// 	this.dialogVisible = true;
		// },

		//上传图片结果
		handleAvatarSuccess(res, file) {
			console.log(res);
			// this.imageUrl = URL.createObjectURL(file.raw);
			if (res.code == 0) {
				that.form.imageUrl = res.data.imgFileList[0].ImgUrl;
			} else {
				that.$message.error(res.msg);
			}
		},
		beforeAvatarUpload(file) {
			console.log(file);
		},

		handleScroll() {
			let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;

			scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
		},
		toTop() {
			let top = document.documentElement.scrollTop || document.body.scrollTop;
			// 实现滚动效果
			const timeTop = setInterval(() => {
				document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
				if (top <= 0) {
					clearInterval(timeTop);
				}
			}, 10);
		},
		bindJumpFeiFei(e){
			let url=util.apiUrl+"/MemberAPI/FeiFei?UserCode="+util.getAccountCode();
			
			window.open(url);
		},
		bindSubmitFeedback(e) {
			console.log(that.form);
			let formData = that.form;
			if (formData.feedbackContent == '') {
				that.$alert('请填写您要反馈的内容');
				return;
			}
			if (formData.name == '') {
				that.$alert('请填写您的称呼');
				return;
			}

			var parm = {
				Email: formData.email,
				Mobile: formData.phone,
				CustomerTitle: '',
				Content: formData.feedbackContent,
				CustomerName: formData.name,
				FeedBackTypeID: formData.productId + 1,
				imglist_box_feedback: formData.imageUrl
			};

			SubmitFeedBack(parm, function(result) {
				if (result.code == 0) {
					that.$alert('感谢您的反馈,我们的客服会尽快处理', {
						confirmButtonText: '确定',
						callback: action => {
							that.showFeedback = false;
						}
					});
				} else {
					that.$alert(result.msg);
				}
			});
		}
	}
};
</script>

<style lang="scss">
.int-foot.bgwhite {
	background: #fff;
	color: #000;
	height: 70px;
	a {
		color: #000;
	}
	margin-top: 20px;
}
</style>
